import { useGet, useQueryWithErrorHandling } from '@app/sdk';

export function useGetPaymentHistory({ accountId }: { accountId: string }) {
  const get = useGet(true, "rp");

  async function getPaymentHistory() {
    return await get<any>(`/api/proxy/rp/regular-payments-service/accounts/${accountId}/payment-history`);
  }

  return useQueryWithErrorHandling({
    queryKey: ['getPaymentHistory', accountId],
    queryFn: getPaymentHistory,
    enabled: !!accountId,
  });
}
